var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"home-container"},[_c('SelfBbreadcrumb',{attrs:{"path":_vm.pathList}}),_c('new-list')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }